export enum EFeatures {
    AUTOMATION = 'AUTOMATION',
    TEAM = 'TEAM',
    PREMIUM_SUPPORT = 'PREMIUM_SUPPORT'
  }